import React from 'react';
import { withRouter } from "react-router";

import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

class Details extends React.Component {
  constructor(props) {
    super(props);
    this.state = props.location.state;
        
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event, v) {
    let userForm = this.state.userForm;
    userForm[v] = event.target.value;
    this.setState({ userForm });
  }

  handleSubmit() {
    let myBody = {};
    myBody.email = this.state.userForm.email;
    myBody.firstname = this.state.userForm.firstname;
    myBody.lastname = this.state.userForm.lastname;
    myBody.isMale = this.state.userForm.isMale;
    myBody.password = this.state.userForm.password;
    myBody.offers = [];
    for (const o of this.state.offers) {
      if (o.selected) {
        myBody.offers.push(o.name);
      }
    }
    const requestOptions = {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' },
      body: JSON.stringify(myBody)
    };
    fetch('https://wiy477tw3h.execute-api.us-east-1.amazonaws.com/default/survey-function', requestOptions)

    this.props.history.push({
      pathname: '/thank-you'
    });
  }

  render() {
    return (
      <div className="body">
        <div className="">
          <div className="banner-panel banner-small">
            <div className="banner-overlay">
              <div className="gradient"></div>
            </div>
          </div>
          <div>
            <Container className="relative">
              <Row className="justify-content-center pb-5">
                <Col md={6}>
                  <div className="signup-form">
                    <Form>
                      <div className="signup-inner">
                        <h4 className="border-bottom pt-3 pb-4">FINAL DETAILS</h4>
                        <h5 className="pt-3 pb-3">Please provide these final details, to ensure you can be matched to relevant paid surveys.</h5>
                        <Form.Group controlId="formBasicEmail">
                          <Form.Control type="password" placeholder="Enter password" value={this.state.userForm.password} onChange={(e) => this.handleChange(e, "password")} />
                        </Form.Group>
                      </div>
                      <Button className="btn btn-primary btn-block" onClick={(e) => this.handleSubmit()} variant="primary">
                        Start earning
                      </Button>
                    </Form>
                  </div>
                </Col>
              </Row>
            </Container>

          </div>
        </div>

        <div className="footer text-center">
          <div className="container">
            <div className="row">
            </div>
            <div className="row">
              <div className="col-12 copyright">
                <ul>
                  <li><a href="">Terms &amp; Conditions</a></li>
                  <li><a href="">Privacy Policy</a></li>
                </ul>
                <p>© 2021 Kensto</p>
                <p>*Based on <a className="text-underline" href="">possible earnings</a>. These differ due to panelist demographics and survey companies selected, results vary per person.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(Details);